import { render, staticRenderFns } from "./tuneUpAlipay.vue?vue&type=template&id=550f497d&scoped=true&"
import script from "./tuneUpAlipay.vue?vue&type=script&lang=js&"
export * from "./tuneUpAlipay.vue?vue&type=script&lang=js&"
import style0 from "./tuneUpAlipay.vue?vue&type=style&index=0&id=550f497d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f497d",
  null
  
)

export default component.exports